<template>
    <div>
        <slot name="content" :selectedValue="selectedValue"></slot>
    </div>
</template>

<script>
    export default {

        props: {
            listener: {
                type: String,
                default: ''
            },
        },

        data() {
            return {
                selectedValue: null
            };
        },
        mounted() {
            this.$root.$on(this.listener  + '-change-value', (val) => {
                this.onChange(val);
            });
        },
        methods: {
            onChange(value){
                this.selectedValue = value;
            }
        }
    }
</script>
